<template>
  <div class="containter" v-loading='loading'>
    <div class="topSelect">
      <div class="item">
        <label>审核状态：</label>
        <el-select v-model="status" @change="init({page:1})" style="width:150px" size="mini" clearable placeholder="订单状态">
          <el-option v-for="(item,index) in statusList" :key="index" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <label>记账月份：</label>
        <el-date-picker @change="init({page:1})" style="width:140px;" v-model="change_month" :clearable='true' type="month" size="mini" value-format="yyyy-MM" placeholder="月份筛选">
        </el-date-picker>
      </div>
      <div class="item">
        <label>财务审核时间：</label>
        <el-date-picker @change="init({page:1})" style="width:240px" v-model="approved_date" type="daterange" value-format="yyyy-MM-dd" size='mini' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div class="item">
        <label>签约公司：</label>
        <el-input placeholder="请输入签约公司" v-model.trim="company" clearable @keydown.enter.native="init({page:1})" @clear="init({page:1})" size="mini" style="width:200px">
          <el-button slot="append" icon="el-icon-search" @click="init({page:1})" style="padding:0 10px"></el-button>
        </el-input>
      </div>
      <div class="item">
        <label>客户全称：</label>
        <el-input placeholder="请输入客户全称" v-model.trim="customer_name" clearable @keydown.enter.native="init({page:1})" @clear="init({page:1})" size="mini" style="width:200px">
          <el-button slot="append" icon="el-icon-search" @click="init({page:1})" style="padding:0 10px"></el-button>
        </el-input>
      </div>
      <div class="item">
        <label>提交人：</label>
        <el-input placeholder="请输入提交人" v-model.trim="operator" clearable @keydown.enter.native="init({page:1})" @clear="init({page:1})" size="mini" style="width:200px">
          <el-button slot="append" icon="el-icon-search" @click="init({page:1})" style="padding:0 10px"></el-button>
        </el-input>
      </div>
    </div>
    <div class="operationUploadBox operationUploadFlex clear" style="margin-top:5px">
      <div class="operationUpload operationUploadFlex">
        <div class="batchDelete" style="background:#d51414;border-color:#d51414" @click="batchDelete">批量删除</div>
        <div class="batchDelete" style="background:#FF9B3B;border-color:#FF9B3B;" @click="clearSelection">清空选中</div>
        <a class="fileTemplate" href='https://order-consumption-system.oss-cn-beijing.aliyuncs.com/templates/%E9%9D%9E%E7%B3%BB%E7%BB%9F%E5%8D%95%E4%BF%AE%E6%94%B9%E5%BD%95%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'>订单导入模板</a>
        <el-upload style="display: inline-block;float: left;" ref="upload" :action="URL.BASEURL + URL.past_orderImport" :on-success="uploadSuccess" :on-error="uploadError" :on-progress='uploadProgress' :data="{
                        admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
                        ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
                        sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign
                    }" :show-file-list='false' :auto-upload="true" accept=".xlsx,.csv">
          <div class="batchDelete">订单批量导入</div>
        </el-upload>
        <div class="batchDelete" @click="aloneAdd">单笔添加</div>
        <div class="item">
          <label style="font-size:12px">任务ID：</label>
          <el-input placeholder="请输入任务ID" v-model.trim="task_id" clearable @keydown.enter.native="init({page:1})" @clear="init({page:1})" size="mini" style="width:200px">
            <el-button slot="append" icon="el-icon-search" @click="init({page:1})" style="padding:0 10px"></el-button>
          </el-input>
        </div>
      </div>
      <div class="refreshIcon batchDelete" @click="init({page:1})">
        刷新
        <i class="el-icon-refresh"></i>
      </div>
      <div class="batchDelete" @click="init({page:1,exportFlag:true})">导出</div>
    </div>
    <div>
      <ux-grid ref="plxTable1" :height="height" show-footer-overflow="tooltip" show-overflow="tooltip" :checkboxConfig="{checkMethod: selectable, highlight: true}" @selection-change="selectionChange" keep-source :edit-config="{trigger: 'manual', mode: 'row'}" size="mini">
        <ux-table-column type="checkbox" align="center" fixed="left" width="40" />
        <ux-table-column v-for="item in columns" :key="item.id" :resizable="true" :field="item.prop" :title="item.label" :width="item.width" :fixed="item.fixed" show-header-overflow='tooltip' :edit-render="false" align="center" />
        <ux-table-column title="状态" align="center" fixed="right" minWidth="100" field="describe">
          <template v-slot="{ row }">
            <span v-if="row.status == 0">已保存</span>
            <span v-if="row.status == 1" style="color:#EF7400">待商务审核</span>
            <span v-if="row.status == 2" style="color:#3265f3">待财务审核</span>
            <span v-if="row.status == 3" style="color:#d51313;">商务审核驳回</span>
            <span v-if="row.status == 4" style="color:#00BB5D;">财务审核通过</span>
            <span v-if="row.status == 5" style="color:#d51313;">财务审核驳回</span>
          </template>
        </ux-table-column>
        <ux-table-column title="操作" align="center" minWidth="120" fixed="right" field="describe">
          <template v-slot="{ row }">
            <span style="color:#ff9b3c;cursor: pointer;margin-right:5px;" v-if="row.is_invoiced==1" @click="revokeInvoiced(row)">撤销标记</span>
            <span style="color:#5B7BFE;cursor: pointer;margin-right:5px;" @click="goDetail(row)">详情</span>
          </template>
        </ux-table-column>
      </ux-grid>
      <div class="paginationBox">
        <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange" layout="total, prev, pager, next, jumper" :total="total" />
      </div>
    </div>
    <el-dialog title="" :visible.sync="editFlag" width="1200px" top="10vh" :close-on-click-modal='false'>
      <add-order v-if="editFlag" :dataInfo='dataInfo' @cancelToast='cancelToast' @emit_refresh="emit_refresh"></add-order>
    </el-dialog>
  </div>
</template>
<script>
import columnsJson from '../../Order/json/total.js'
import addOrder from './add_order'
export default {
  components: {
    addOrder
  },
  data () {
    return {
      pickerOptionsMonth: {
        disabledDate (time) {
          return time.getTime() > new Date('2021-03-31 00:00:00');
        },
      },
      editFlag: false,
      height: 400,
      columns: [],
      page: 1,
      page_size: 100,
      total: 0,
      loading: false,
      multipleSelection: [],
      multipleSelection1: {},
      selectionList: [],
      flag: false,
      status: '',
      statusList: [
        { id: '', name: '不限' },
        { id: 0, name: '保存' },
        { id: 1, name: '待商务审核' },
        { id: 2, name: '待财务审核' },
        { id: 3, name: '商务审核驳回' },
        { id: 4, name: '财务审核通过' },
        { id: 5, name: '财务审核驳回' },
      ],
      dataInfo: {},
      editFlag: false,
      change_month: '',
      approved_date: [],
      task_id: '',
      company: '',
      customer_name: '',
      operator: ''
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    this.columns = columnsJson

    this.init({ page: 1 })
  },
  mounted () {
    this.height = document.documentElement.clientHeight - 241 > 400 ? document.documentElement.clientHeight - 241 : 400
  },
  methods: {
    batchDelete () {//批量删除
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$message({
          message: '未选择要删除的订单',
          type: 'warning'
        })
        return
      }
      this.$confirm('确定要删除所选中订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var arr = [];
        this.multipleSelection.forEach((item) => {
          arr.push(item.id)
        })
        this.$loading(this.$loadingConfig)
        this.$axios.post(this.URL.BASEURL + this.URL.past_batchDel, {
          ids: arr
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.$message({
              message: '删除成功！',
              type: 'success'
            })
            this.init({ page: 1 })
          } else {
            this.$loading(this.$loadingConfig).close()
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.$loading(this.$loadingConfig).close()
        })
      }).catch(() => {
      });
    },
    clearSelection () {//清空选中
      if (this.$refs.plxTable1) {
        this.$refs.plxTable1.clearSelection();
      }
      this.multipleSelection1 = {};
      this.multipleSelection = [];
      this.selectionList = []
    },
    emit_refresh () {//编辑成功
      this.editFlag = false;
      this.init({ page: this.page })
    },
    cancelToast () {
      this.editFlag = false;
    },
    goDetail (data) {
      this.dataInfo = data;
      this.editFlag = true;
    },
    aloneAdd () {
      this.dataInfo = {}
      this.editFlag = true
    },
    handleCurrentChange (val) {
      this.init({ page: val, selection: 'clear' })
    },
    init ({ page, exportFlag, selection }) {
      if (!selection || selection != 'clear') {
        this.clearSelection()
      }
      var params = {
        page: page,
        pagesize: this.page_size,
        status: this.status,
        change_month: this.change_month,
        approved_start_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[0] : '',
        approved_end_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[1] : '',
        task_id: this.task_id,
        company: this.company,
        customer_name: this.customer_name,
        operator: this.operator,
      }
      if (exportFlag) {
        params.page = 1;
        params.pagesize = 10000
      } else {
        page = page ? page : 1;
        params.page = page;
        this.page = page;
      }
      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.past_index, {
        params
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          var data = res.rst;
          if (exportFlag) {
            this.$exportOrder({ source: 'all', dataList: data.data, name: '2021.04之前消耗表' })
          } else {
            this.total = data.pageInfo.total;
            this.datas = data.data // 知道为啥datas不在 data()方法里面定义吗？嘻嘻
            this.$refs.plxTable1.reloadData(this.datas)
            this.$nextTick(() => {
              if (this.multipleSelection1['page_' + this.page] && this.multipleSelection1['page_' + this.page].length != 0) {
                var rows = [], arr = []
                this.multipleSelection1['page_' + this.page].forEach((item) => {
                  arr.push(item.id)
                })
                rows = this.datas.filter((v) => {
                  return arr.indexOf(v.id) != -1
                })
                this.flag = false
                this.toggleSelection(rows)
              } else {
                this.flag = true
              }
            })
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    selectable ({ row }) {//选择表格限制条件
      return row.status != 2 && row.status != 5
    },
    selectionChange (row) {// 选中的行
      this.selectionList = row
      if (this.flag) {
        this.multipleSelection1['page_' + this.page] = this.selectionList;
        this.multipleSelection = [];
        for (var i in this.multipleSelection1) {
          this.multipleSelection = this.multipleSelection.concat(this.multipleSelection1[i])
        }
      }
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach((row, index) => {
          this.$refs.plxTable1.toggleRowSelection([
            {
              row: row,
              selected: true
            }
          ])
          if (index == rows.length - 1) {
            this.flag = true
          }
        });
      }
    },
    uploadSuccess (res, file, fileList) {
      this.$loading(this.$loadingConfig).close()
      if (res.errno == 0) {
        var not_exists = `<p>${res.rst.info ? res.rst.info : '导入成功！'}</p>`
        this.$alert(not_exists, res.err, {
          dangerouslyUseHTMLString: true
        });
        this.init({ page: 1 })
      } else {
        var errHint = '';
        if (Array.isArray(res.rst.error)) {
          errHint = '<p>有误字段：</p><ul>'
          res.rst.error.forEach((item) => {
            errHint += `<li>第${item.row}行：${item.error.join(',')}</li>`
          })
          errHint += '</ul>'
        } else {
          errHint = res.rst.error
        }
        this.$alert(errHint, res.err, {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }
    },
    uploadError (err, file, fileList) {
      this.$loading(this.$loadingConfig).close()
      this.$alert('上传失败', '服务器错误', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        callback: action => {
        }
      });
    },
    uploadProgress () {//上传中
      this.$loading(this.$loadingConfig)
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../statements/list.scss";
.topSelect {
  padding-bottom: 0;
}
.operationUploadBox {
  margin: 0px 20px 10px;
}
.operationUploadFlex {
  display: flex;
  align-items: center;
}
.operationUpload {
  flex: 1;
}
.fileTemplate {
  font-size: 12px;
  margin-right: 10px;
  text-decoration: underline;
  margin: 8px 10px 0 0;
  color: #5b7bfe;
  display: block;
}
.batchDelete {
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #5b7bfe;
  background: #5b7bfe;
  color: #fff;
  margin-right: 16px;
  cursor: pointer;
  padding: 0 4px;
}
.refreshIcon {
  margin-right: 10px;
  background: #67c23a;
  border-color: #67c23a;
}
</style>
<style lang="scss">
.topSelect {
  .el-range-editor--mini .el-range-separator {
    width: 20px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BeforeApril/order/pastList.vue